import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const MonthlyEvaluationFormat = () => {
  const data = [
    ['Month', 'Reports Submitted'],
    ['January', 95],
    ['February', 90],
    ['March', 92],
    ['April', 94],
    ['May', 93],
  ];

  const options = {
    title: 'Monthly Evaluation Reports Submitted',
    hAxis: { title: 'Month' },
    vAxis: { title: 'Reports Submitted (%)' },
    legend: { position: 'top' },
    curveType: 'function',
    colors: ['#4CAF50'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="LineChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default MonthlyEvaluationFormat;